import { Box } from '@mui/material';
import styled from 'styled-components';

import { TIconContainerProps } from '@/shared/components/ui/icon-container/icon-container.types';

export const IconContainer = styled(Box)<TIconContainerProps>`
  && {
    border-radius: ${({ theme }) => theme.shape.avatarRadius};
    background-color: ${({ theme, $color = 'blue' }) =>
      theme.palette.status[$color].background};
    width: 3.75rem;
    height: 3.75rem;
    display: flex;
    justify-content: center;
    align-items: center;

    svg {
      width: 1.75rem;
      height: 1.75rem;
      color: ${({ theme, $color = 'blue' }) =>
        $color === 'blue'
          ? theme.palette.primary.main
          : theme.palette.status[$color].text};
    }
  }
`;
